export enum FeedbackRatingType {
  Positive = 'Positive',
  Neutral = 'Neutral',
  Negative = 'Negative',
  Withdrawn = 'Withdrawn',
  IndependentlyWithdrawn = 'IndependentlyWithdrawn',
}
